import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'Fiscal',
      name: i18n.t('tipos.rol_administrativecenter.fiscal'),
    },
    {
      id: 'Payer',
      name: i18n.t('tipos.rol_administrativecenter.payer'),
    },
    {
      id: 'Buyer',
      name: i18n.t('tipos.rol_administrativecenter.buyer'),
    },
    {
      id: 'Collector',
      name: i18n.t('tipos.rol_administrativecenter.collector'),
    },
    {
      id: 'Seller',
      name: i18n.t('tipos.rol_administrativecenter.seller'),
    },
    {
      id: 'Payment receiver',
      name: i18n.t('tipos.rol_administrativecenter.payment_receiver'),
    },
    {
      id: 'Collection receiver',
      name: i18n.t('tipos.rol_administrativecenter.collection_receiver'),
    },
    {
      id: 'Issuer',
      name: i18n.t('tipos.rol_administrativecenter.issuer'),
    },
  ]
}

export function TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B (state) {
  return configHelper.getConfig(state, 'TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B', GenerateConfig)
}
